/* eslint-disable */

// react
import React, {useEffect, useState} from "react";

//MUI
import { Box, Divider, Stack, Grid, Button, Typography} from "@mui/material";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import USelectBox from "../../components/mui/USelectBox";
import UButton from "../../components/mui/UButton";
import UDatePickers from "../../components/mui/UDatePickers";
import UPopupForm from "../../components/mui/UPopupForm";
import UTable from "../../components/mui/UTable";

// API
import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import { getAPI} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import TotalDetailPopup from './TotalDetailPopup';

export default function TotalPage() {
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const columns = [
        {
            field: 'Date',
            headerName: '일자',
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"1"
        },
        {
            field: 'MachineID',
            headerName: '기기번호',
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"2",
            hide:true
        },
        {
            field: 'branchName',
            headerName: '지점',
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'brandNm',
            headerName: '브랜드',
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"2",
        },
        {
            field: 'deposit',
            headerName: '입금',
            width: 350,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"3",
            colSpan: [
                {
                    parentField: 'deposit',
                    field: 'sellCnt',
                    headerName: '총매수',
                    width: 100,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: 'deposit',
                    field: 'sellTotal',
                    headerName: '총금액',
                    width: 100,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
            ],
        },
        {
            field: 'dispense',
            headerName: '출금',
            width: 350,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"4",
            valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return Number(params.value).toLocaleString('en-US');
            },
            colSpan: [
                {
                    parentField: 'dispense',
                    field: 'buyCnt',
                    headerName:  '총매수',
                    width: 100,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: 'dispense',
                    field: 'buyTotal',
                    headerName:  '총금액',
                    width: 100,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
            ],
        },
        {
            field: 'exchange',
            headerName: '현금교환',
            width: 350,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"6",
            colSpan: [
                {
                    parentField: 'exchange',
                    field: 'exchangeCnt',
                    headerName: '총매수',
                    width: 100,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: 'exchange',
                    field: 'exchangeTotal',
                    headerName: '총금액',
                    width: 100,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                },
            ],
        },
        {
            field: 'Detail',
            headerName: '상세',
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
            id:"7",
            renderCell: (params) =>
             (          
                <UButton variant="outlined" onButtonClick={() => onButtonClick(params.rows)}>보기</UButton>
             ),
        },
    ];
    const [branchList, setBranchList] = useState([{}]);             //지점
    const [machineList, setMachineList] = useState([]);             //기번
    const [transType,setTransType] = useState([]);                  //거래타입
    const [IOType,setIOType] = useState([]);                        //입출금타입
    const [brands, setBrands] = useState([]);                       //스토어
    const [retailers, setRetailers] = useState([]);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [ formOpen, setFormOpen ] = useState(false);//popup open State
    const now = new Date().toISOString().slice(0, 10).replace(/-/g,"");
    const [search, setSearch] = useState({//검색조건
        // storeCd: "N/A",             //점번
        // brandCd:"N/A",              //스토어
        // branchName:"",              //지점명
        startDate: now,             //시작일
        endDate: now,               //종료일
        // machine:"",                 //기번
        // trans:"",                   //거래타입 (마감입금, 준비금출금, 현금교환 ... )
        // ioType:"",                  //입출금타입 (입금,출금,입출금 ... )
    });
    const [gridData, setGridData] = useState([]);//거래집계 & 상세 Grid 표시 데이터

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async() => {
            try {
                await Promise.all([
                    loadComboBoxBranchGroup(),
                    loadComboBoxBranch()//지점명
                ]);
            } catch (e) {
                console.error('초기 로딩 실패:', e.message);
            }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.storeCd) {
            getGridData();//거래집계
            setIsFirstLoad(false);
        }
    }, [search]);

    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['storeCd']: 'N/A',
        });
        setMachineList([]);
        setBrands([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    // 지점명 가져오기 콤보박스 데이터
    const loadComboBoxBranch = async(param) => {
        try{
            let res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            let data = res.data.result.map((m) => ({
                    cd:m.storeCd,
                    name:m.storeNm,
                })
            );
            setBranchList(data);
            if (data.length > 0){
                await loadComboBoxBrand(data[0].cd);
            } else{
                clearSearchVal()
            }
        }catch(e){
            console.log("[TotalPage.jsx] loadComboBoxBranch() Exception => "+e.message);
        }
    };

    // 거래타입 가져오기
    const getTransType = async() => {
        try{
            let res = await getAPI(API.COMMON.TRANS_TYPE);
            let data = res.data.result.map((m) => ({
                    cd:m.cd,
                    name:m.cdShortNm,
                })
            );
            setTransType(data);
        }catch(e){
            console.log("[TotalPage.jsx] getTransType() Exception => "+e.message);
        }
    }

    // 입출금코드 가져오기
    const getIOType = async() => {
        try{
            let res = await getAPI(API.COMMON.IN_OUT);
            let data = res.data.result.map((m) => ({
                    cd:m.cd,
                    name:m.cdShortNm,
                })
            );
            setIOType(data);
        }catch(e){
            console.log("[TotalPage.jsx] getIOType() Exception => "+e.message);
        }
    }
    
    // 기번 가져오기
    const getMachineList = async(param) => {
        try{
            let res = await getAPI(API.COMMON.MACHINE+param);
            let data = res.data.result.map((m) => ({
                    cd:m.machId,
                    name:m.machId,
                })
            );
            setMachineList(data);
        }catch(e){
            console.log("[TotalPage.jsx] getMachineList() Exception => "+e.message);
        }        
    };

    const loadComboBoxBrand = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch});
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['brandCd'] : _inputData[0].cd,
                    ['storeCd'] : branch,
                })
            } else {
                setSearch({
                    ...search,
                    ['brandCd'] : "N/A",
                    ['storeCd'] : branch,
                })
            }
            setBrands(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };

    //화면들어올때 자동조회 - 거래집계
    const getGridData = async() => {
        const res = await getAPI(API.TRANS.TOTAL, search);
        const inputData = res.data.result.map((rowData) => ({
            id:rowData.no, //no
            Date:rowData.tranDate,//거래날짜
            branchName:rowData.storeNm,//지점명
            storeCd:rowData.storeCd,//지점번호
            MachineID:rowData.machId,//기번
            brandNm:rowData.brand,//브랜드
            brandCd:rowData.brandCd,
            sellTotal: isNaN(rowData.closeAmt)?"0":"$"+Number(rowData.closeAmt).toLocaleString("en-US"),// 마감
            sellCnt:rowData.closeCnt,
            buyTotal: isNaN(rowData.tillAmt)?"0":"$"+Number(rowData.tillAmt).toLocaleString("en-US"),// 준비금출금
            buyCnt:rowData.tillCnt,
            exchangeTotal: isNaN(rowData.exchngAmt)?"0":"$"+Number(rowData.exchngAmt).toLocaleString("en-US"),// 현금교환
            exchangeCnt: rowData.exchngCnt,
                
        }));
        setGridData(inputData);
    }

    //버튼 클릭
    async function onButtonClick(dvsn) {
        if(dvsn == "조회"){
            const res = await getAPI(API.TRANS.TOTAL, search);
            const inputData = res.data.result.map((rowData) => ({
                id:rowData.no, //no
                Date:rowData.tranDate,//거래날짜
                branchName:rowData.storeNm,//지점명
                storeCd:rowData.storeCd,//지점코드
                MachineID:rowData.machId,//지점명
                brandNm:rowData.brand,//브랜드
                brandCd:rowData.brandCd,
                sellTotal: isNaN(rowData.closeAmt)?"0":"$"+Number(rowData.closeAmt).toLocaleString("en-US"),// 마감
                sellCnt:rowData.closeCnt,
                buyTotal: isNaN(rowData.tillAmt)?"0":"$"+Number(rowData.tillAmt).toLocaleString("en-US"),// 준비금출금
                buyCnt:rowData.tillCnt,
                exchangeTotal: isNaN(rowData.exchngAmt)?"0":"$"+Number(rowData.exchngAmt).toLocaleString("en-US"),// 현금교환
                exchangeCnt: rowData.exchngCnt,
            }));
            setGridData(inputData);
        }else{
            handleRowSelect(dvsn);
        }
    };

    //폼 팝업
    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    //콤보박스 아이템 선택
    const onChangeCombo = (e) => {
        const { name, value } = e.target;
        setSearch({
          ...search,
          [name]: value,
        });
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        if (name === "storeCd") {
            loadComboBoxBrand(value);
        }
    };
    
    //  날짜선택
    const onChangeDate = (e) => {
        const { name, value } = e.target;
        let val = value.replace(/\-/g,'');        
        setSearch({
            ...search,
            [name]: val,
        });
    }

    //상세팝업 클릭이벤트핸들러
    const handleRowSelect = (row) => {
        setSearch({
            ...search,
            ['startDate']: row.Date.replace(/\//g,""),
            ['endDate']: row.Date.replace(/\//g,""),
            ['storeCd']: row.storeCd,
            ['branchName']: row.branchName,
            // ['machId']: row.MachineID,
            ['brandNm']: row.brandNm,
        });
        handleFormOpen();   //상세팝업
    }
    
    return (
        <div className="main-container">
            <Box className="header">
                <Grid container>
                    <Grid item xs={10}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs title={'거래정보'} subtitle={'거래집계'} />
                    </Grid>
                    <Grid item xs={2}>
                        {/* 툴바 버튼 */}
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            spacing={4}
                        >
                        </Stack>
                    </Grid>
                </Grid>
            </Box>

            <div className="contents">
                <Box>
                    <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow className="table-row-header">
                                <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                                <TableCell className="table-cell">
                                    <USelectBox
                                        name="bizTy"
                                        items={retailers}
                                        onItemChange={onChangeCombo}
                                    />
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                                <TableCell className="table-cell">
                                    {/* 점번선택 */}
                                    <USelectBox id="storeCd" name="storeCd" items={branchList} onItemChange={onChangeCombo} defaultValue={search.storeCd}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                                <TableCell className="table-cell">
                                    {/* 브랜드 */}
                                    <USelectBox id="brandCd" name="brandCd" items={brands} onItemChange={onChangeCombo} defaultValue={search.brandCd}/>
                                </TableCell>

                                <TableCell className="table-cell-title">{fni18n('일자')}</TableCell>
                                <TableCell className="table-cell" colSpan={3}>
                                    {/* 날짜선택 */}
                                    <UDatePickers onChange={onChangeDate} />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                    <div className="search">
                        <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                    </div>
                </Box>
            
                {/* 테이블 */}
                <UTable columns={columns} rows={gridData} rowPerPage={11}/>
                
                {/* 팝업 */}
                <UPopupForm
                    title={"거래 상세"}
                    open={formOpen}
                    onClose={handleFormClose}
                    content={<TotalDetailPopup data={search} />}
                    type={"1"}
                    maxWidth={"xl"}
                />
            </div>
        </div>
    );
}